import styled from "styled-components";

import { BodyG } from "../../styles/stylesTypography";
import { CardPlans } from "../cardRadio/styles";

export const ContainerMethod = styled.div`
  width: 100%;
  height: auto;

  gap: 16px;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  justify-content: center;

  /* Wrapper do CardRadio: vira flex para o card esticar ate a altura da linha,
     deixando os tres cards com a mesma altura. */
  > div {
    display: flex;
  }

  ${CardPlans} {
    /* Ocupa toda a altura da linha para que o radio possa ser empurrado ate a base. */
    height: 100%;
    text-align: center;

    /* Ultimo filho flex com margin-top auto: alinha os radios dos tres cards na mesma
       altura, independente do tamanho do texto de cada um. */
    .radio-wrapper {
      margin-top: auto;
    }
  }

  @media (max-width: 769px) {
    flex-wrap: wrap;
    flex-direction: column;

    > div {
      height: auto;
    }
  }
`;

export const TituloCard = styled(BodyG)`
  text-align: center;
`;
